import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakAuthService } from 'src/app/services/keyclok-auth.service';

@Component({
  selector: 'app-oauth-callback',
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.scss']
})
export class OAuthCallbackComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private keycloakAuthService: KeycloakAuthService,
    public translateService:TranslateService
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('session_state');
    console.log('code', code)
    console.log('state', state);

    if (code && state) {
      // 'http://localhost:4200/'
      this.keycloakAuthService.requestToken('https://se2.tech/', state, code)
        .subscribe(
          (token) => {
            localStorage.setItem('token', token);
            if (window.opener) {
              window.opener.postMessage({ type: 'SOCIAL_LOGIN_SUCCESS', token }, '*');
            }
            window.close();
          },
          err => {
            console.error('Token request failed', err);
            window.close();
          }
        );
    } else {
      console.warn('Missing code or session_state in URL');
      window.close();
    }
  }

}
